/* Sydney Aero Parts 2026 rebuild: product page behaviour. Original code, written for SAP. */
(function () {
  'use strict';
  function money(c) { return window.SAP && SAP.money ? SAP.money(c) : '$' + (c / 100).toFixed(2); }

  function initProduct(root) {
    if (root.dataset.sapInit) return; root.dataset.sapInit = '1';
    var dataEl = root.querySelector('[data-product-json]');
    var data = { variants: [] };
    try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var form = root.querySelector('[data-sap-form]') || root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var errEl = root.querySelector('[data-error]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var sticky = root.querySelector('[data-sticky-atc]');
    var stickyBtn = root.querySelector('[data-sticky-add]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyVariant = root.querySelector('[data-sticky-variant]');
    var gallery = root.querySelector('[data-sap-gallery]');
    var single = data.variants.length <= 1;
    var L = { add: 'Add to cart', sold: 'Sold out', unavailable: 'Unavailable', pick: (addBtn && addBtn.dataset.pickLabel) || 'Select an option' };
    var dyn = root.querySelector('.sap-pp__dyn');

    // recently viewed
    if (window.SAP && SAP.rvPush) SAP.rvPush(root.dataset.handle);

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('.sap-opt'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function setButtons(v, incomplete) {
      var label = incomplete ? L.pick : !v ? L.unavailable : v.available ? L.add : L.sold;
      var dis = incomplete || !v || !v.available;
      if (dyn) {
        if (incomplete) { dyn.setAttribute('data-needs-pick', ''); dyn.setAttribute('aria-disabled', 'true'); }
        else { dyn.removeAttribute('data-needs-pick'); dyn.removeAttribute('aria-disabled'); }
      }
      [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = dis; });
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) stickyBtn.textContent = label;
    }
    function markAvailability() {
      // cross out values that have no available variant given the other current choices
      var opts = selected();
      root.querySelectorAll('.sap-opt').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var any = data.variants.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j < test.length; j++) if (j !== idx && test[j] != null && v.options[j] !== test[j]) return false;
            return v.options[idx] === inp.value;
          });
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !any);
        });
      });
    }
    function update() {
      var opts = selected();
      root.querySelectorAll('.sap-opt').forEach(function (fs, i) { var s = fs.querySelector('[data-option-value]'); if (s) s.textContent = opts[i] || ''; });
      var incomplete = opts.some(function (o) { return o == null; });
      var v = incomplete ? null : findVariant(opts);
      setButtons(v, incomplete);
      markAvailability();
      if (!v) return;
      idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) { priceWas.hidden = !(v.compare > v.price); priceWas.textContent = v.compare > v.price ? money(v.compare) : ''; }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyVariant && !single) stickyVariant.textContent = v.title + ' · ';
      try {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
      if (v.media && gallery) {
        var item = gallery.querySelector('[data-media-id="' + v.media + '"]');
        if (item) {
          if (window.matchMedia('(max-width: 1023px)').matches) gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        }
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.sap-opt')) update(); });
    markAvailability();
    if (!single && selected().some(function (o) { return o == null; })) setButtons(null, true);

    // quantity stepper
    var qtyInput = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });

    // add to cart
    function showError(msg) { if (!errEl) return; errEl.textContent = msg; errEl.hidden = !msg; }
    if (form) form.addEventListener('submit', function (e) {
      if (!idInput.value) { e.preventDefault(); showError(L.pick + '.'); return; }
      if (!window.fetch || !window.SAP || !SAP.addToCart) return;
      e.preventDefault();
      showError('');
      addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true');
      var qty = parseInt((root.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
      SAP.addToCart([{ id: parseInt(idInput.value, 10), quantity: qty }]).catch(function (err) {
        if (err && err.message) showError(err.message); else form.submit();
      }).then(function () {
        addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy');
      });
    });

    // sticky add-to-cart bar
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
        });
      });
      io.observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    // mobile gallery index
    var idx = root.querySelector('[data-gallery-index]');
    if (gallery && idx) gallery.addEventListener('scroll', function () {
      var w = gallery.clientWidth || 1;
      idx.textContent = String(Math.round(gallery.scrollLeft / w) + 1);
    }, { passive: true });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-sap-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
